import { ContractEsActions, EContractEsActions } from "@edp-store/actions/ES/contract-es.actions";
import { IContractEsState, initialContractEsState } from "@edp-store/state/ES/contract-es.state";

export function contractEsReducers(
    state = initialContractEsState,
    action: ContractEsActions
): IContractEsState {
    switch (action.type) {
        case EContractEsActions.SetContractsEs: {
            return {
                ...state,
                contractsEs: action.payload
            };
        }
        case EContractEsActions.SelectContractEs: {
            return {
                ...state,
                selectedContractEs: {
                    data: action.contract,
                    lastAPIError: null
                }
            };
        }
        case EContractEsActions.SelectedContractAPIErrorEs: {
            return {
                ...state,
                selectedContractEs: {
                    ...state.selectedContractEs,
                    lastAPIError: action.error
                }
            };
        }
        case EContractEsActions.IsSingleContractEs: {
            return {
                ...state,
                isSingleContractEs: action.payload
            };
        }
        // case EContractEsActions.ClearSelectedContractData: {
        //     return {
        //         ...state,
        //         ...initialContractResetState
        //     };
        // }
        default:
            return state;
    }
}
